import styled from 'styled-components';
import { breakpoints } from 'themes/helpers';
import { PageProps } from './Page';

export const PageWrapper = styled.div<PageProps>`
  display: flex;
  height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  --page-header-height: 116px;

  @media (min-width: ${() => breakpoints.tablet}px) {
    --page-header-height: 63px;
  }
`;

export const Main = styled.main<PageProps>`
  flex-grow: 1;
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
